import { ContentMap } from '../types';
import { thailandArticlesContentMap } from './thailand/thailand-articles-card-map';
import { cambodiaArticlesContentMap } from './cambodia/cambodia-articles-card-map';
import { vietnamArticlesContentMap } from './vietnam/vietnam-articles-card-map';

export const articlesContent: ContentMap = {
  ...thailandArticlesContentMap,
  ...cambodiaArticlesContentMap,
  ...vietnamArticlesContentMap,
};
